/** Plain-English labels for status-vs-reality flags (the API sends the enum value, e.g. `closed_but_inbound`). */
const FLAG_LABEL: Record<string, string> = {
  open_but_waiting_customer: 'set Desk to Waiting Client Response',
  triage_watch: 'Riley says keep an eye on this',
  waiting_but_customer_replied: 'customer replied while waiting',
  in_progress_silent: 'in progress, gone quiet',
  closed_but_inbound: 'closed, but the customer wrote again',
  scheduled_past: 'scheduled date has passed',
  no_next_move: 'no next move',
  time_not_logged: 'no time logged',
  contractor_unexpected: 'contractor wrote with no work order',
  over_nte: 'over the not-to-exceed',
  draft_withheld: 'draft withheld by the guard',
  identity_unresolved: 'customer not identified',
  spam_rescued: 'rescued from spam',
  double_bill_risk: 'double-bill risk',
  disclosure_risk: 'disclosure risk: contractor message on a customer contact',
  status_move_mismatch: 'Desk status disagrees with the next move',
  brand_unmapped_department: 'Desk department not mapped to a brand',
  delivery_failed: 'our reply bounced: the customer did not get it',
}

export function flagLabel(kind: string): string {
  return FLAG_LABEL[kind] ?? kind.replaceAll('_', ' ')
}
